import firebaseService from "../firebase/FirebaseService";
import { getFile } from './FileService';
import { addActivityToGroup, removeActivityOfGroup, removeActivityFromUser } from './NewGroupService';
import { getCycleById } from './CycleService';
import { getUserById } from "./UserService";
import { getLocationById } from "./LocationService";

export const createActivity = async (payload, image, addGroupsActivity) => {
  if (image) {
    await firebaseService.uploadFile(image);
    payload.image_ref = `${image.name}_330x330.${image.extension}`;
  }

  return firebaseService
    .createActivity(payload)
    .then(async (response) => {
      const activityId = response.id;

      const userResponse = await addActivityToGroupProcess(activityId, addGroupsActivity)
        .then((response) => {
          return response;
        })
        .catch(e => {
          return "error";
        });

      if (userResponse === "error")
        return "error";

      return activityId;
    })
    .catch((e) => {
      return "error";
    });
};

export const updateActivity = async (activityId, payload, image, addGroupsActivity, removeGroupsActivity) => {
  if (image) {
    await firebaseService.uploadFile(image);
    payload.image_ref = `${image.name}_330x330.${image.extension}`;
  }

  return firebaseService
    .updateActivity(activityId, payload)
    .then(async (response) => {
      const userResponse = await addActivityToGroupProcess(activityId, addGroupsActivity, removeGroupsActivity)
        .then((response) => {
          return response;
        })
        .catch(e => {
          return "error";
        });

      if (userResponse === "error")
        return "error";

      return response;
    })
    .catch((e) => {
      return "error";
    });
};

export const removeUsersFromActivity = async (activityId, users) => {
  const activityFunctions = [];

  if (users) {
    users.forEach(studentId => {
      activityFunctions.push(removeActivityFromUser(studentId, activityId));
    });
  }

  return Promise.all(activityFunctions).then(response => {
    return Promise.resolve(response);
  }).catch(error => {
    return Promise.reject({
      error: error
    });
  });
}

export const addActivityToGroupProcess = async (activityId, addGroups, removeGroups) => {
  const userFunctions = [];

  if (addGroups) {
    addGroups.forEach(group => {
      userFunctions.push(addActivityToGroup(activityId, group.id));
    });
  }

  if (removeGroups) {
    removeGroups.forEach(group => {
      userFunctions.push(removeActivityOfGroup(activityId, group.id));
    });
  }

  return Promise.all(userFunctions).then(response => {
    return Promise.resolve(response);
  }).catch(error => {
    return Promise.reject({
      error: error
    });
  });
}

export const getActivities = async () => {
  return firebaseService
    .getActivities()
    .then(async (response) => {

      await Promise.all(response.map(async (data) => {
        const result = await getCycleById(data.cycle);
        data.nameCycle = result.name;
        const contactName = await getUserById(data.contact)
        data.nameContact = contactName.displayName;
      }));
      return response;

    })
    .catch((error) => {
      return [];
    });
};

export const getTeacherActivities = async (teacher) => {
  return firebaseService
    .getTeacherActivities(teacher)
    .then(async (response) => {

      await Promise.all(response.map(async (data) => {
        const result = await getCycleById(data.cycle);
        data.nameCycle = result.name;
        const contactName = await getUserById(data.contact)
        data.nameContact = contactName.displayName;
      }));
      return response;

    })
    .catch((error) => {
      return [];
    });
};

export const getActivityById = async (activityId, userId) => {
  return firebaseService
    .getActivityById(activityId)
    .then(async (response) => {
      const userActivity = await firebaseService.getUserActivity(
        activityId,
        userId
      );

      response.subscribed = userActivity.studentId !== undefined;

      const contactName = await getUserById(response.contact);
      response.nameContact = contactName.displayName;

      const locationData = await getLocationById(response.direction);
      response.nameLocation = locationData.name;
      response.descriptionLocation = locationData.description;

      response.image_url = await getFile(response.image_ref);

      return response;
    })
    .catch((error) => {
      return {};
    });
};
